import { render } from "./ProgramsCarousel.vue?vue&type=template&id=111441d4"
import script from "./ProgramsCarousel.vue?vue&type=script&lang=js"
export * from "./ProgramsCarousel.vue?vue&type=script&lang=js"

import "./ProgramsCarousel.vue?vue&type=style&index=0&id=111441d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__